import { useNetworkStatus } from "../hooks/use-network-status";

export function OfflineBanner() {
	const { online } = useNetworkStatus();

	if (online) return null;

	return (
		<div
			data-testid="offline-banner"
			className="bg-amber-50 border-b border-amber-200 px-4 py-2 text-center text-sm text-amber-800"
		>
			You are currently offline. Some features may be unavailable.
		</div>
	);
}
